module.exports = __webpack_public_path__ + "google_podcasts-6d4d34448790042bcf36.svg";